export default __webpack_public_path__ + "static/media/profilepic.62322921.jpg";